/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_ReplyingInputs */

const en_settings_tickets_replying = /** @type {(inputs: Settings_Tickets_ReplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Settings_Tickets_ReplyingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_replying = /** @type {((inputs?: Settings_Tickets_ReplyingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_ReplyingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_replying(inputs)
});
export { settings_tickets_replying as "settings.tickets.replying" }